/* Speed Junkies HQ - 14-day countdown gate.
   Any element with [data-sj-cd-gate] is shown or hidden purely on how far the
   official end date is away. Nothing here changes entry maths or giveaway data.

   Attributes
     data-sj-cd-gate="clock"  -> visible only when the end date is <= N days away (or already passed)
     data-sj-cd-gate="pre"    -> visible only when the end date is still further away than N days
     data-sj-cd-end="ISO"     -> official end date. A bare date-time is read as UTC.
     data-sj-cd-days="14"     -> threshold in days (default 14)

   State is mirrored on the element as data-sj-cd-state:
     early | visible | ended | invalid
*/
(function () {
  'use strict';
  if (window.SJCountdownGate) return;

  var DAY = 86400000;

  function parseEnd(v) {
    if (!v) return null;
    var s = String(v).trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T23:59:59Z';
    if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(s)) s = s.replace(' ', 'T') + 'Z';
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function threshold(el) {
    var n = parseFloat(el.getAttribute('data-sj-cd-days'));
    if (isNaN(n) || n < 0) n = 14;
    return n;
  }

  function evaluate(el) {
    if (!el) return 'invalid';
    var role = (el.getAttribute('data-sj-cd-gate') || 'clock').toLowerCase();
    var end = parseEnd(el.getAttribute('data-sj-cd-end'));
    var state;

    if (!end) {
      state = 'invalid';
    } else {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) state = 'ended';
      else if (diff <= threshold(el) * DAY) state = 'visible';
      else state = 'early';
    }

    if (el.getAttribute('data-sj-cd-state') !== state) el.setAttribute('data-sj-cd-state', state);

    var show;
    if (role === 'pre') show = (state === 'early');
    else show = (state === 'visible' || state === 'ended');

    if (el.hidden === show) el.hidden = !show;
    return state;
  }

  function refresh(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-sj-cd-gate]');
    for (var i = 0; i < nodes.length; i++) evaluate(nodes[i]);
    return nodes.length;
  }

  window.SJCountdownGate = { evaluate: evaluate, refresh: refresh, parse: parseEnd };

  function boot() { refresh(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  /* Re-check every second so the clock flips on exactly at the 14 day mark and
     switches to the ended state the moment the giveaway closes. */
  setInterval(boot, 1000);

  document.addEventListener('shopify:section:load', function (ev) { refresh(ev.target); });
})();
